import React, { createContext, useContext, useEffect, useState } from 'react'
import { useAuthentication } from './authenticationContext'
import Swal from 'sweetalert2'

import {
  /*   getProvincesByCountry,
   */ getListCountry,
  getFormStates,
  getAlphabeticalOrders,
  getListCountryWithCode,
  getListStatesWithCode,
  getListStatesDraftWithCode,
  getGeneros,
} from '../pages/Formularios/data/data'
import {
  getListForm,
  getSectors,
  getActivity,
  getMiPymeType,
  getCurrencies,
  getDepartments,
  getMunicipalities,
  getDetailsForms,
  getCountries,
  getClimateThreat,
  getAdaptationActions,
  getBusinessLine,
  getQuestions,
  getProjectsCode,
  getStage,
  getProjectsName,
  getListDraftForms,
  getActualForm,
  getPDF,
  getListMypmes,
} from '../services/Forms/get'
import { getFormularioPrelegibilidad, getPreIFIPDF } from '../services/IFI/get'
import { deleteDraftForm } from '../services/Forms/delete'

const FormContext = createContext()
export const FormContextProvider = ({ children }) => {
  const { userCountry, userCompanyID, userIDB2C } = useAuthentication()
  const [fetchRequest, setFetchRequest] = useState(['landing_page'])
  const [step, setStep] = useState(1)
  const [preEligibilityForm, setPreEligibilityForm] = useState({})
  const [adaptationActions, setAdaptationActions] = useState([])
  /*   const [provinces, setProvinces] = useState([])
   */ const [countries, setCountries] = useState([])
  const [formStates, setFormStates] = useState([])
  const [geners, setGeners] = useState([])
  const [alphaOrders, setAlphaOrders] = useState([])
  const [listForms, setListForms] = useState([])
  const [countriesCodes, setCountriesCodes] = useState([])
  const [statesCodes, setStatesCodes] = useState([])
  const [statesCodesDraft, setStatesCodesDraft] = useState([])
  const [filtersArray, setFiltersArray] = useState([])
  const [sectors, setSectors] = useState([])
  const [activitySector, setActivitySector] = useState([])
  const [sectorID, setSectorID] = useState(null)
  const [activityID, setActivityID] = useState(null)
  const [miPymesType, setMiPymes] = useState([])
  const [currencies, setCurrencies] = useState([])
  const [departments, setDepartments] = useState([])
  const [municipilaties, setMunicipilaties] = useState([])
  const [municipilatiesID, setMunicipilatiesID] = useState('')
  const [ActualPage, setActualPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [pagesCount, setPagesCount] = useState(0)
  const [ActualDraftPage, setActualDraftPage] = useState(1)
  const [pageDraftSize, setPageDraftSize] = useState(10)
  const [pagesDraftCount, setPagesDraftCount] = useState(0)
  const [listDraftForms, setListDraftForms] = useState(0)
  const [detailsListForm, setDetailsListForm] = useState(0)
  const [idDetailForm, setIdDetailForm] = useState(null)
  const [listCountries, setListCountries] = useState([])
  const [climateThreat, setClimateThreat] = useState([])
  const [lineOfBusiness, setLineOfBusiness] = useState([])
  const [userActualCountry, setActualCountry] = useState('')
  const [questions, setQuetions] = useState([])
  const [questionsData, setQuetionsData] = useState([])
  const [projectCode, setProjectCode] = useState([])
  const [stage, setStage] = useState([])
  const [projectName, setProjectName] = useState([])
  const [projectNameDraft, setProjectNameDraft] = useState([])

  const [editForm, setEditForm] = useState([])
  const [idEditForm, setIdEditForm] = useState([])
  const [dollarAmount, setDollarAmount] = useState('0')
  const [loadingPDF, setLoadingPDF] = useState(false)

  const [editLoading, setEditLoading] = useState(false)
  const [globalLoading, setGlobalLoading] = useState(false)

  const [pymeList, setPymeList] = useState([])

  const [checkPYME, setCheckPYME] = useState(false)

  const [toast, setToast] = useState({
    show: false,
    message: undefined,
    severity: undefined,
  })
  useEffect(() => {}, [preEligibilityForm])
  const getGeneralData = async () => {
    setEditLoading(true)
    const dataCountries = await getCountries()
    const filterCountry = dataCountries.Data.filter(
      (item) => item.IdCountry === parseInt(userCountry),
    )
    setActualCountry(filterCountry[0].LargeName)

    const climateThreat = await getClimateThreat()

    setClimateThreat(climateThreat.Data)

    const adaptationActions = await getAdaptationActions()
    setAdaptationActions(adaptationActions.Data)

    const lineOfBusiness = await getBusinessLine()
    setLineOfBusiness(lineOfBusiness.Data)

    const sectors = await getSectors(userCountry)
    setSectors(sectors.Data)

    const currencies = await getCurrencies(userCountry)
    setCurrencies(currencies.Data)

    const departments = await getDepartments(userCountry)

    setDepartments(departments.Data)

    /* const provinces = getProvincesByCountry(userCountry)
    setProvinces(provinces) */

    const alphabetical = getAlphabeticalOrders()
    setAlphaOrders(alphabetical)

    const states = getFormStates()
    setFormStates(states)

    const country = getListCountry()
    setCountries(country)

    getMiPymeList()
    const geners = getGeneros()
    setGeners(geners)
  }

  const getData = async () => {
    await setGlobalLoading(true)
    const data = await getMiPymeType()
    setMiPymes(data.Data)
    const dataCountries = await getCountries()
    setListCountries(dataCountries.Data)
  }

  useEffect(() => {
    if (
      listCountries &&
      listCountries.length > 0 &&
      miPymesType &&
      miPymesType.length > 0
    ) {
      setInterval(function () {
        setGlobalLoading(false)
      }, 1000)
    }
  }, [listCountries, miPymesType])

  const getForms = async () => {
    setListForms({ loading: true, list: [] })

    const countriesCode = await getListCountryWithCode()
    setCountriesCodes(countriesCode)

    detailsPage()

    const projectsCode = await getProjectsCode(userCompanyID)
    setProjectCode(projectsCode.projectPreElegibilityCodes)

    const stages = await getStage()
    setStage(stages.Data)

    const projectsName = await getProjectsName(userCompanyID, false)
    setProjectName(projectsName.projectPreElegibilityNames)

    await getListForm('mipyme', ActualPage, pageSize)
      .then((res) => {
        const list = res?.formsPreElegibility
        const count = pagesCounter(res?.pagination.totalRecords, pageSize)
        setPagesCount(count)
        setListForms({ loading: false, list: list })
      })
      .catch((err) => {
        console.log(err)
        setListForms({ loading: false, list: [] })
      })
  }

  const getSectorActivityForm = async () => {
    const activity = await getActivity(userCountry, sectorID)
    setActivitySector(activity.Data)
  }

  const getMunicipalityList = async () => {
    const municipilaties = await getMunicipalities(municipilatiesID)
    setMunicipilaties(municipilaties.Data)
  }

  const pagesCounter = (len, pageSize) => {
    const counter = Math.ceil(len / pageSize)
    if (counter < 1) {
      return 1
    } else {
      if (len % 2 === 0) {
        return counter
      } else {
        if (len % 1 === 0) {
          return counter
        }
      }
    }
  }

  const getDetailsForm = async () => {
    setDetailsListForm({ loading: true, list: '' })

    const list = await getDetailsForms(idDetailForm)
    setDetailsListForm({ loading: false, list: list.formPreElegibilityDetail })
  }
  const getDetailsFormIFI = async () => {
    setDetailsListForm({ loading: true, list: '' })
    const response = await getFormularioPrelegibilidad(idDetailForm)
    if (response.Code === 200) {
      const values = response.Data
      setDetailsListForm({ loading: false, list: values })
    } else {
      setDetailsListForm({ loading: true, list: '' })
    }
  }
  const getDetailsFormMipyme = async () => {
    setDetailsListForm({ loading: true, list: '' })
    const response = await getFormularioPrelegibilidad(idDetailForm)
    if (response.Code === 200) {
      const values = response.Data
      setDetailsListForm({ loading: false, list: values })
    } else {
      setDetailsListForm({ loading: true, list: '' })
    }
  }

  const updateStatusForm = async () => {}

  const detailsPage = async () => {
    const statesCodes = await getListStatesWithCode()
    setStatesCodes(statesCodes)
  }

  const getQuestionActivity = async () => {
    setQuetions([])
    if (sectorID !== null && activityID !== null) {
      const questions = await getQuestions(userCountry, sectorID, activityID)
      setQuetions(questions.Data.Questions)
    }
  }

  const getDraftListForm = async () => {
    setListDraftForms({ loading: true })

    const statesCodes = await getListStatesDraftWithCode()
    setStatesCodesDraft(statesCodes)

    const stages = await getStage()
    setStage(stages.Data)

    const projectName = await getProjectsName(userCompanyID, true)
    setProjectNameDraft(projectName.Data)

    let list
    await getListDraftForms(false, ActualDraftPage, pageDraftSize)
      .then((res) => {
        if (!res.response.ok) {
          setListDraftForms({ loading: false, list: [] })
        } else {
          list = res?.formsPreElegibility
          const pages = pagesCounter(
            res?.pagination.totalRecords,
            pageDraftSize,
          )
          setPagesDraftCount(pages)
          setListDraftForms({ loading: false, list: list })
        }
      })
      .catch((err) => {
        console.log(err)
        setListDraftForms({ loading: false })
      })
  }

  const deleteDraftForms = async (idForm, endpointType) => {
    setListDraftForms({ loading: true })

    await deleteDraftForm(idForm)
      .then((res) => {
        getDraftListForm(false, ActualDraftPage, pageDraftSize)

        if (endpointType === 'CreateForm') {
          return ''
        } else {
          if (res.response.ok) {
            Swal.fire({
              title: 'Borrado',
              text: 'El formulario fue borrado con éxito',
              icon: 'success',
              confirmButtonColor: '#28a745',
              confirmButtonText: 'Entendido',
              allowOutsideClick: false,
            })
          } else {
            Swal.fire({
              title: 'Error',
              text: 'Ha ocurrido un error',
              icon: 'error',
            })
          }
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  useEffect(() => {
    if (
      lineOfBusiness &&
      lineOfBusiness.length > 0 &&
      sectors &&
      sectors.length > 0 &&
      currencies &&
      currencies.length > 0 &&
      countries &&
      countries.length > 0 &&
      formStates &&
      formStates.length > 0 &&
      climateThreat &&
      climateThreat.length > 0 &&
      adaptationActions &&
      adaptationActions.length > 0 &&
      departments &&
      departments.length > 0 &&
      alphaOrders &&
      alphaOrders.length > 0
    ) {
      setEditLoading(true)
      if (pymeList && pymeList.length > 0) {
        setInterval(function () {
          setEditLoading(false)
        }, 1000)
      } else {
        setInterval(function () {
          setEditLoading(false)
        }, 1000)
      }
    }
  }, [lineOfBusiness, sectors, currencies, countries, formStates])

  const getEditForm = async () => {
    setEditForm({ loading: true, list: '' })

    await getActualForm(idEditForm).then((res) => {
      if (res.response.ok) {
        const data = res.formPreElegibilityDetail
        mapAnswerForEdit(data)
        setEditForm({ loading: false, list: data })
      } else {
        setEditForm({ loading: false, list: '' })
      }
    })
  }

  const getEditFormByIFI = async () => {
    setEditForm({ loading: true, list: '' })
    if (idEditForm !== []) {
      const response = await getFormularioPrelegibilidad(idEditForm)
      if (response !== undefined) {
        if (response.Code === 200) {
          const values = response.Data
          mapAnswerForEdit(values)
          setEditForm({ loading: false, list: values })
        } else {
          setEditForm({ loading: false, list: '' })
        }
      }
    }
  }

  const mapAnswerForEdit = (data) => {
    const questionAux = []
    if (data && data.annexAnswer && data.annexAnswer.length > 0) {
      for (let i = 0; i < data.annexAnswer.length; i++) {
        const q = {
          idActivityQuestion: data.annexAnswer[i].idActivityQuestion,
          value: data.annexAnswer[i].answer,
          activityQuestion: data.annexAnswer[i].activityQuestion,
          questionTypeName: data.annexAnswer[i].questionTypeName,
          valueType: data.annexAnswer[i].questionTypeName,
        }
        questionAux.push(q)
      }
      setQuetionsData(questionAux)
    }
  }

  const getActualDate = () => {
    const hoy = new Date()
    const meses = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ]

    const arrayData = []
    const fecha =
      hoy.getDate() + '-' + meses[hoy.getMonth()] + '-' + hoy.getFullYear()
    const minutos = (hoy.getMinutes() < 10 ? '0' : '') + hoy.getMinutes()
    let horas = hoy.getHours()
    const ampm = horas >= 12 ? 'PM' : 'AM'
    horas = horas % 12
    const date = fecha + ' ' + horas + ':' + minutos + ':' + ampm

    arrayData.push(date)
    arrayData.push(fecha)

    return arrayData
  }

  const downloadPDF = async (idForm, codeForm, projectName) => {
    if (idForm !== null) {
      setLoadingPDF(true)
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Generando Archivo',
        text: 'Iniciando descarga',
        showConfirmButton: false,
        timer: 2000,
        allowOutsideClick: false,
      })
      const date = await getActualDate()
      await getPDF(idForm, date[0]).then((response) => {
        if (response instanceof Blob) {
          setLoadingPDF(false)
          const blob = URL.createObjectURL(response)
          const link = document.createElement('a')
          let filename
          if (codeForm !== undefined) {
            filename = 'Formulario#' + codeForm
          }
          if (projectName !== undefined) {
            filename = 'Formulario - ' + projectName
          }
          link.href = blob
          link.download = filename
          document.body.append(link)
          link.click()
          link.remove()
          setLoadingPDF(false)
        } else {
          setLoadingPDF(false)

          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ha ocurrido un error al intentar generar el pdf',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Reintentar',
            footer:
              '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
        }
      })
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ha ocurrido un error al intentar generar el pdf',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Reintentar',
        footer:
          '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
    }
  }

  const downloadPreMIPYMEPDF = async (idForm, codeForm, projectName) => {
    if (idForm !== null) {
      setLoadingPDF(true)
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Generando Archivo',
        text: 'Iniciando descarga',
        showConfirmButton: false,
        timer: 2000,
        allowOutsideClick: false,
      })
      const date = await getActualDate()
      await getPreIFIPDF(idForm, date[0]).then((response) => {
        if (response) {
          setLoadingPDF(false)
          const blob = URL.createObjectURL(response)
          const link = document.createElement('a')
          let filename
          if (codeForm !== '') {
            filename = 'Formulario#' + codeForm
          }
          if (projectName !== undefined) {
            filename = 'Formulario - ' + projectName
          }
          link.href = blob
          link.download = filename

          document.body.append(link)
          link.click()
          link.remove()
          setLoadingPDF(false)
        } else {
          setLoadingPDF(false)

          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ha ocurrido un error al intentar generar el pdf',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Reintentar',
            footer:
              '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
        }
      })
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ha ocurrido un error al intentar generar el pdf',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Reintentar',
        footer:
          '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
    }
  }
  const downloadPreIFIPDF = async (idForm, codeForm, projectName) => {
    if (idForm !== null) {
      setLoadingPDF(true)
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Generando Archivo',
        text: 'Iniciando descarga',
        showConfirmButton: false,
        timer: 2000,
        allowOutsideClick: false,
      })
      const date = await getActualDate()
      await getPreIFIPDF(idForm, date[0]).then((response) => {
        if (response) {
          setLoadingPDF(false)
          const blob = URL.createObjectURL(response)
          const link = document.createElement('a')
          let filename
          if (codeForm !== '') {
            filename = 'Formulario#' + codeForm
          }
          if (projectName !== undefined) {
            filename = 'Formulario - ' + projectName
          }
          link.href = blob
          link.download = filename

          document.body.append(link)
          link.click()
          link.remove()
          setLoadingPDF(false)
        } else {
          setLoadingPDF(false)

          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ha ocurrido un error al intentar generar el pdf',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Reintentar',
            footer:
              '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
        }
      })
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ha ocurrido un error al intentar generar el pdf',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Reintentar',
        footer:
          '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
    }
  }

  const getMiPymeList = async () => {
    await getListMypmes(userIDB2C)
      .then((res) => {
        if (res.Data.length > 0) {
          setPymeList(res.Data)
        } else {
          setPymeList([])
        }
      })
      .catch((err) => {
        console.log(err)
        setPymeList([])
      })
  }

  useEffect(() => {
    if (fetchRequest) {
      if (fetchRequest.includes('create_form')) getGeneralData()
      if (fetchRequest.includes('landing_page')) getData()
      if (fetchRequest.includes('details_page')) detailsPage()
      if (fetchRequest.includes('view_form')) getForms()
      if (fetchRequest.includes('view_draft_form')) getDraftListForm()
      if (fetchRequest.includes('edit_page')) getEditFormByIFI()
      if (fetchRequest.includes('edit_page_ifi')) getEditFormByIFI()
    }
  }, [fetchRequest])

  return (
    <FormContext.Provider
      value={{
        // isLoading,
        step,
        setStep,
        setFetchRequest,
        preEligibilityForm,
        setPreEligibilityForm,
        climateThreat,
        adaptationActions,
        lineOfBusiness,
        //  provinces,
        toast,
        setToast,
        countries,
        geners,
        formStates,
        alphaOrders,
        listForms,
        countriesCodes,
        setFiltersArray,
        setListForms,
        filtersArray,
        statesCodes,
        getForms,
        sectors,
        activitySector,
        setActivitySector,
        setSectorID,
        getSectorActivityForm,
        miPymesType,
        currencies,
        departments,
        municipilaties,
        getMunicipalityList,
        setMunicipilatiesID,
        municipilatiesID,
        ActualPage,
        setActualPage,
        setPageSize,
        pageSize,
        pagesCount,
        pagesCounter,
        getDetailsForm,
        detailsListForm,
        getDetailsFormIFI,
        getDetailsFormMipyme,
        setIdDetailForm,
        idDetailForm,
        updateStatusForm,
        listCountries,
        userActualCountry,
        getQuestionActivity,
        questions,
        sectorID,
        setActivityID,
        activityID,
        setQuetions,
        questionsData,
        setQuetionsData,
        projectCode,
        stage,
        projectName,
        listDraftForms,
        pagesDraftCount,
        ActualDraftPage,
        setActualDraftPage,
        pageDraftSize,
        setPageDraftSize,
        getDraftListForm,
        deleteDraftForms,
        getEditForm,
        getEditFormByIFI,
        editForm,
        setIdEditForm,
        idEditForm,
        setPagesCount,
        setListDraftForms,
        statesCodesDraft,
        setPagesDraftCount,
        projectNameDraft,
        setDollarAmount,
        dollarAmount,
        fetchRequest,
        setEditForm,
        downloadPDF,
        setLoadingPDF,
        loadingPDF,
        editLoading,
        getData,
        globalLoading,
        getMiPymeList,
        pymeList,
        checkPYME,
        setCheckPYME,
        downloadPreIFIPDF,
        downloadPreMIPYMEPDF,
      }}
    >
      {children}
    </FormContext.Provider>
  )
}
export const useForm = () => {
  const context = useContext(FormContext)
  if (context === undefined) {
    throw new Error('useForm can only be used inside FormProvider')
  }
  return context
}
